export const modularLibraryArrangementCopy = {
  en: {
    fixedDesk: 'The reading desk stays in place.',
    structureHint: 'Select a divider to merge or restore shelves.',
    selectNamed: 'Select {{name}}',
    items: 'Items',
    movedPlantHint: 'This plant is already displayed elsewhere. Applying will move it here.',
    editHint: 'Tap a shelf to add something, or select an item to arrange it.',
    selectHint: 'Select an item, shelf or divider.',
    selectedShelf: 'Row {{row}} · Shelf {{number}}',
    chooseShelf: 'Choose another shelf',
    add: 'Add',
    replace: 'Replace',
    move: 'Move',
    remove: 'Remove from shelf',
    removeShort: 'Remove',
    cover: 'Cover facing',
    spine: 'Spine facing',
    coverShort: 'Cover',
    spineShort: 'Spine',
    bookDisplay: 'Book display',
    coverChoiceHint: 'Choose one book to display cover facing.',
    batchChooseHint: 'Select books to place spine facing together.',
    batchFullHint: 'This book does not fit with the selection. Deselect a book to make room.',
    batchInvalidSelection: 'This selection no longer fits. Deselect a book to make room.',
    selectionError: 'Could not prepare this selection. Try again.',
    batchSelectedCount: '{{count}} selected',
    batchCapacity: 'Shelf space remaining: {{percent}}%',
    batchPreview_one: 'Preview {{count}} book',
    batchPreview_other: 'Preview {{count}} books',
    batchMoveNotice_one: '{{count}} selected book will move from its current shelf.',
    batchMoveNotice_other: '{{count}} selected books will move from their current shelves.',
    batchBooks_one: '{{count}} book',
    batchBooks_other: '{{count}} books',
    batchPlace_one: 'Place {{count}} book',
    batchPlace_other: 'Place {{count}} books',
    batchPlaced_one: '{{count}} book placed.',
    batchPlaced_other: '{{count}} books placed.',
    changeBooks: 'Change books',
    undo: 'Undo',
    cancel: 'Cancel',
    done: 'Done',
    place: 'Place',
    confirmReplace: 'Replace',
    confirmMove: 'Move here',
    previewHint: 'Check the placement, then confirm. Nothing changes until you do.',
    noSpace: 'There is not enough room here. Choose another shelf or make more space.',
    notFound: 'This item is no longer available. Choose another item.',
    unsupported: 'This item cannot be placed on this shelf.',
    invalid: 'This position is not available. Choose another position.',
    dividerBlocked: 'An item occupies this divider’s space. Move it before restoring the divider.',
    added: 'Added to the shelf.',
    replaced: 'Replaced. The previous item is back in your collection.',
    moved: 'Moved to the new position.',
    removed: 'Returned to your collection.',
    changed: 'Arrangement updated.',
    cancelled: 'Changes cancelled.',
    myBooksCollection: 'My Books · Shelf changes stay in this prototype.',
    searchBooks: 'Search title or author',
    clearSearch: 'Clear search',
    bookCategory: 'Book category',
    booksLoading: 'Loading your books…',
    booksError: 'Could not refresh My Books. Try again.',
    booksUnavailable: 'Your books are unavailable right now.',
    noMatchingBooks: 'No books match these filters.',
    noMyBooks: 'Add a book in My Books to display it here.',
    demoReadingDesk: 'Demo reading desk',
    localCollection: 'Demo collection · Changes stay in this prototype.',
    uniqueBookHint: 'Each book can appear once. Move a displayed book to change its shelf.',
    alreadyPlaced: 'Already placed',
    moveHere: 'Move here',
    choose: 'Choose',
    collection: 'Your collection',
    books: 'Books',
    collectibles: 'Collectibles',
    plantOptions: 'Plant options',
    turnOn: 'Turn on',
    turnOff: 'Turn off',
    previousShelf: 'Previous shelf',
    nextShelf: 'Next shelf',
    previousItem: 'Previous item',
    nextItem: 'Next item',
    shelf: 'Shelf',
    row: 'Row',
    position: 'Position',
    left: 'Left',
    right: 'Right',
    resetArrangement: 'Reset arrangement',
    selectShelf: 'Select shelf',
    selectItem: 'Select item',
    selectDivider: 'Select divider',
    addTitle: 'Add to your shelf',
    replaceTitle: 'Choose a replacement',
    closePicker: 'Close collection',
    categories: 'Collection category',
    empty: 'No items in this category.',
    chooseItem: '{{action}} · {{name}}',
    movePlacedHint: 'Preview moving this item from its current shelf.',
    chooseHint: 'Preview this item on the selected shelf.',
    plantPreviewHint:
      'Preview the plant, pot and trailing length. Apply when you are happy with the combination.',
    apply: 'Apply',
    closePlantOptions: 'Cancel plant changes',
  },
  sk: {
    fixedDesk: 'Čitateľský stôl zostáva na svojom mieste.',
    structureHint: 'Vyberte priečku na zlúčenie alebo obnovenie políc.',
    selectNamed: 'Vybrať: {{name}}',
    items: 'Predmety',
    movedPlantHint: 'Táto rastlina je už vystavená inde. Potvrdením ju presuniete sem.',
    editHint: 'Ťuknutím na policu pridáte predmet. Výberom predmetu zmeníte jeho umiestnenie.',
    selectHint: 'Vyberte predmet, policu alebo priečku.',
    selectedShelf: 'Rad {{row}} · Polica {{number}}',
    chooseShelf: 'Vybrať inú policu',
    add: 'Pridať',
    replace: 'Nahradiť',
    move: 'Presunúť',
    remove: 'Odobrať z police',
    removeShort: 'Odobrať',
    cover: 'Obálkou dopredu',
    spine: 'Chrbtom dopredu',
    coverShort: 'Obálka',
    spineShort: 'Chrbát',
    bookDisplay: 'Vystavenie knihy',
    coverChoiceHint: 'Vyberte jednu knihu, ktorú vystavíte obálkou dopredu.',
    batchChooseHint: 'Vyberte knihy, ktoré vystavíte spolu chrbtom dopredu.',
    batchFullHint: 'Táto kniha sa k výberu nezmestí. Uvoľnite miesto odobratím vybranej knihy.',
    batchInvalidSelection: 'Tento výber sa už nezmestí. Odoberte z výberu knihu a uvoľnite miesto.',
    selectionError: 'Nepodarilo sa pripraviť tento výber. Skúste to znova.',
    batchSelectedCount: 'Vybrané knihy: {{count}}',
    batchCapacity: 'Voľné miesto na polici: {{percent}} %',
    batchPreview_one: 'Náhľad {{count}} knihy',
    batchPreview_few: 'Náhľad {{count}} kníh',
    batchPreview_many: 'Náhľad {{count}} kníh',
    batchPreview_other: 'Náhľad {{count}} kníh',
    batchMoveNotice_one: '{{count}} vybraná kniha sa presunie zo svojej police.',
    batchMoveNotice_few: '{{count}} vybrané knihy sa presunú zo svojich políc.',
    batchMoveNotice_many: '{{count}} vybraných kníh sa presunie zo svojich políc.',
    batchMoveNotice_other: '{{count}} vybraných kníh sa presunie zo svojich políc.',
    batchBooks_one: '{{count}} kniha',
    batchBooks_few: '{{count}} knihy',
    batchBooks_many: '{{count}} knihy',
    batchBooks_other: '{{count}} kníh',
    batchPlace_one: 'Umiestniť {{count}} knihu',
    batchPlace_few: 'Umiestniť {{count}} knihy',
    batchPlace_many: 'Umiestniť {{count}} knihy',
    batchPlace_other: 'Umiestniť {{count}} kníh',
    batchPlaced_one: '{{count}} kniha bola umiestnená.',
    batchPlaced_few: '{{count}} knihy boli umiestnené.',
    batchPlaced_many: '{{count}} knihy bolo umiestnených.',
    batchPlaced_other: '{{count}} kníh bolo umiestnených.',
    changeBooks: 'Zmeniť knihy',
    undo: 'Späť',
    cancel: 'Zrušiť',
    done: 'Hotovo',
    place: 'Umiestniť',
    confirmReplace: 'Nahradiť',
    confirmMove: 'Presunúť sem',
    previewHint: 'Skontrolujte umiestnenie a potvrďte ho. Dovtedy sa nič nezmení.',
    noSpace: 'Tu nie je dosť miesta. Vyberte inú policu alebo uvoľnite priestor.',
    notFound: 'Tento predmet už nie je dostupný. Vyberte iný.',
    unsupported: 'Tento predmet sa nedá umiestniť na túto policu.',
    invalid: 'Táto pozícia nie je dostupná. Vyberte inú.',
    dividerBlocked: 'Na mieste priečky je predmet. Pred obnovením priečky ho presuňte.',
    added: 'Pridané na policu.',
    replaced: 'Nahradené. Pôvodný predmet je opäť vo vašej zbierke.',
    moved: 'Presunuté na nové miesto.',
    removed: 'Vrátené do vašej zbierky.',
    changed: 'Usporiadanie bolo upravené.',
    cancelled: 'Zmeny boli zrušené.',
    myBooksCollection: 'Moje knihy · Zmeny políc zostávajú v tomto prototype.',
    searchBooks: 'Hľadať názov alebo autora',
    clearSearch: 'Vymazať vyhľadávanie',
    bookCategory: 'Kategória kníh',
    booksLoading: 'Načítavajú sa vaše knihy…',
    booksError: 'Nepodarilo sa obnoviť Moje knihy. Skúste to znova.',
    booksUnavailable: 'Vaše knihy sú momentálne nedostupné.',
    noMatchingBooks: 'Týmto filtrom nezodpovedajú žiadne knihy.',
    noMyBooks: 'Pridajte knihu do Mojich kníh a vystavte ju tu.',
    demoReadingDesk: 'Ukážkový čitateľský stôl',
    localCollection: 'Ukážková zbierka · Zmeny zostávajú v tomto prototype.',
    uniqueBookHint: 'Každá kniha môže byť vystavená iba raz. Na inú policu ju presuniete.',
    alreadyPlaced: 'Už umiestnené',
    moveHere: 'Presunúť sem',
    choose: 'Vybrať',
    collection: 'Vaša zbierka',
    books: 'Knihy',
    collectibles: 'Predmety',
    plantOptions: 'Možnosti rastliny',
    turnOn: 'Zapnúť',
    turnOff: 'Vypnúť',
    previousShelf: 'Predchádzajúca polica',
    nextShelf: 'Nasledujúca polica',
    previousItem: 'Predchádzajúci predmet',
    nextItem: 'Nasledujúci predmet',
    shelf: 'Polica',
    row: 'Rad',
    position: 'Pozícia',
    left: 'Vľavo',
    right: 'Vpravo',
    resetArrangement: 'Obnoviť pôvodné usporiadanie',
    selectShelf: 'Vybrať policu',
    selectItem: 'Vybrať predmet',
    selectDivider: 'Vybrať priečku',
    addTitle: 'Pridať na policu',
    replaceTitle: 'Vybrať náhradu',
    closePicker: 'Zavrieť zbierku',
    categories: 'Kategória zbierky',
    empty: 'V tejto kategórii nie sú žiadne predmety.',
    chooseItem: '{{action}} · {{name}}',
    movePlacedHint: 'Zobrazí náhľad presunu predmetu z jeho aktuálnej police.',
    chooseHint: 'Zobrazí náhľad predmetu na vybranej polici.',
    plantPreviewHint:
      'Pozrite si rastlinu, kvetináč a dĺžku výhonkov. Vybranú kombináciu potom potvrďte.',
    apply: 'Použiť',
    closePlantOptions: 'Zrušiť zmeny rastliny',
  },
  cs: {
    fixedDesk: 'Čtenářský stůl zůstává na svém místě.',
    structureHint: 'Vyberte příčku pro sloučení nebo obnovení polic.',
    selectNamed: 'Vybrat: {{name}}',
    items: 'Předměty',
    movedPlantHint: 'Tato rostlina je už vystavena jinde. Potvrzením ji přesunete sem.',
    editHint: 'Klepnutím na polici přidáte předmět. Výběrem předmětu změníte jeho umístění.',
    selectHint: 'Vyberte předmět, polici nebo příčku.',
    selectedShelf: 'Řada {{row}} · Police {{number}}',
    chooseShelf: 'Vybrat jinou polici',
    add: 'Přidat',
    replace: 'Nahradit',
    move: 'Přesunout',
    remove: 'Odebrat z police',
    removeShort: 'Odebrat',
    cover: 'Obálkou dopředu',
    spine: 'Hřbetem dopředu',
    coverShort: 'Obálka',
    spineShort: 'Hřbet',
    bookDisplay: 'Vystavení knihy',
    coverChoiceHint: 'Vyberte jednu knihu, kterou vystavíte obálkou dopředu.',
    batchChooseHint: 'Vyberte knihy, které vystavíte společně hřbetem dopředu.',
    batchFullHint: 'Tato kniha se k výběru nevejde. Uvolněte místo odebráním vybrané knihy.',
    batchInvalidSelection: 'Tento výběr se už nevejde. Odeberte z výběru knihu a uvolněte místo.',
    selectionError: 'Nepodařilo se připravit tento výběr. Zkuste to znovu.',
    batchSelectedCount: 'Vybrané knihy: {{count}}',
    batchCapacity: 'Volné místo na polici: {{percent}} %',
    batchPreview_one: 'Náhled {{count}} knihy',
    batchPreview_few: 'Náhled {{count}} knih',
    batchPreview_many: 'Náhled {{count}} knih',
    batchPreview_other: 'Náhled {{count}} knih',
    batchMoveNotice_one: '{{count}} vybraná kniha se přesune ze své police.',
    batchMoveNotice_few: '{{count}} vybrané knihy se přesunou ze svých polic.',
    batchMoveNotice_many: '{{count}} vybraných knih se přesune ze svých polic.',
    batchMoveNotice_other: '{{count}} vybraných knih se přesune ze svých polic.',
    batchBooks_one: '{{count}} kniha',
    batchBooks_few: '{{count}} knihy',
    batchBooks_many: '{{count}} knihy',
    batchBooks_other: '{{count}} knih',
    batchPlace_one: 'Umístit {{count}} knihu',
    batchPlace_few: 'Umístit {{count}} knihy',
    batchPlace_many: 'Umístit {{count}} knihy',
    batchPlace_other: 'Umístit {{count}} knih',
    batchPlaced_one: '{{count}} kniha byla umístěna.',
    batchPlaced_few: '{{count}} knihy byly umístěny.',
    batchPlaced_many: '{{count}} knihy bylo umístěno.',
    batchPlaced_other: '{{count}} knih bylo umístěno.',
    changeBooks: 'Změnit knihy',
    undo: 'Zpět',
    cancel: 'Zrušit',
    done: 'Hotovo',
    place: 'Umístit',
    confirmReplace: 'Nahradit',
    confirmMove: 'Přesunout sem',
    previewHint: 'Zkontrolujte umístění a potvrďte ho. Do té doby se nic nezmění.',
    noSpace: 'Tady není dost místa. Vyberte jinou polici nebo uvolněte prostor.',
    notFound: 'Tento předmět už není dostupný. Vyberte jiný.',
    unsupported: 'Tento předmět nelze umístit na tuto polici.',
    invalid: 'Tato pozice není dostupná. Vyberte jinou.',
    dividerBlocked: 'Na místě příčky je předmět. Před obnovením příčky ho přesuňte.',
    added: 'Přidáno na polici.',
    replaced: 'Nahrazeno. Původní předmět je opět ve vaší sbírce.',
    moved: 'Přesunuto na nové místo.',
    removed: 'Vráceno do vaší sbírky.',
    changed: 'Uspořádání bylo upraveno.',
    cancelled: 'Změny byly zrušeny.',
    myBooksCollection: 'Moje knihy · Změny polic zůstávají v tomto prototypu.',
    searchBooks: 'Hledat název nebo autora',
    clearSearch: 'Vymazat vyhledávání',
    bookCategory: 'Kategorie knih',
    booksLoading: 'Načítají se vaše knihy…',
    booksError: 'Nepodařilo se obnovit Moje knihy. Zkuste to znovu.',
    booksUnavailable: 'Vaše knihy jsou momentálně nedostupné.',
    noMatchingBooks: 'Těmto filtrům neodpovídají žádné knihy.',
    noMyBooks: 'Přidejte knihu do Mojich knih a vystavte ji zde.',
    demoReadingDesk: 'Ukázkový čtenářský stůl',
    localCollection: 'Ukázková sbírka · Změny zůstávají v tomto prototypu.',
    uniqueBookHint: 'Každá kniha může být vystavená jen jednou. Na jinou polici ji přesunete.',
    alreadyPlaced: 'Již umístěno',
    moveHere: 'Přesunout sem',
    choose: 'Vybrat',
    collection: 'Vaše sbírka',
    books: 'Knihy',
    collectibles: 'Předměty',
    plantOptions: 'Možnosti rostliny',
    turnOn: 'Zapnout',
    turnOff: 'Vypnout',
    previousShelf: 'Předchozí police',
    nextShelf: 'Následující police',
    previousItem: 'Předchozí předmět',
    nextItem: 'Následující předmět',
    shelf: 'Police',
    row: 'Řada',
    position: 'Pozice',
    left: 'Vlevo',
    right: 'Vpravo',
    resetArrangement: 'Obnovit původní uspořádání',
    selectShelf: 'Vybrat polici',
    selectItem: 'Vybrat předmět',
    selectDivider: 'Vybrat příčku',
    addTitle: 'Přidat na polici',
    replaceTitle: 'Vybrat náhradu',
    closePicker: 'Zavřít sbírku',
    categories: 'Kategorie sbírky',
    empty: 'V této kategorii nejsou žádné předměty.',
    chooseItem: '{{action}} · {{name}}',
    movePlacedHint: 'Zobrazí náhled přesunu předmětu z jeho aktuální police.',
    chooseHint: 'Zobrazí náhled předmětu na vybrané polici.',
    plantPreviewHint:
      'Prohlédněte si rostlinu, květináč a délku výhonků. Vybranou kombinaci potom potvrďte.',
    apply: 'Použít',
    closePlantOptions: 'Zrušit změny rostliny',
  },
} as const;
